// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toggle[data-v-9d14f444]{all:unset;cursor:pointer;color:#78a6b8}.toggle[data-v-9d14f444]:focus,.toggle[data-v-9d14f444]:hover{color:#d5d5d5}", ""]);
// Exports
module.exports = exports;
